/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Reset_PasswordInputs */



/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Auth_Verify_Reset_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_reset_password = /** @type {((inputs?: Auth_Verify_Reset_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Reset_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialisez votre mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablezca su contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Redefina sua senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta la tua password")
	return /** @type {LocalizedString} */ ("Reset your password")
});